import { Breadcrumbs, Grid, Stack, Typography } from '@mui/material'
import React from 'react'
import { Helmet } from 'react-helmet'

import Content from 'components/common/Content'
import { PrepareToDefineServicesTutorial } from 'components/getting-started/PrepareToDefineServicesTutorial'
import { ReliabilityManagement101 } from 'components/getting-started/ReliabilityManagement101'
import Icon from 'components/Icon'
import { Header } from 'components/navigation/Header'
import { infraClientsSelector, useInfraClientsStore } from 'hooks/use-clients'
import theme from 'theme'
import { ClientState, ClientStatus } from 'types/api/attacks/client'

export const GettingStartedPage: React.FC = () => {
  const allHostClients = useInfraClientsStore(infraClientsSelector)
  const activeClients = allHostClients?.filter(
    (c) => c.state === ClientState.Active
  )
  const allHealthyClients = activeClients
    ?.map((c) => c?.validation_results)
    .filter(
      (v) => v?.client_status === ClientStatus.HEALTHY || !v?.client_status
    )

  return (
    <>
      <Helmet title="Getting Started" />
      <Header>
        <Breadcrumbs aria-label="breadcrumb">
          <Stack alignItems="center" direction="row">
            <Icon css={{ marginRight: theme.space[2] }} icon="graduationCap" />{' '}
            <Typography color="text.primary">Getting Started</Typography>
          </Stack>
        </Breadcrumbs>
      </Header>
      <Content>
        <Typography pb={0} variant="h5">
          Welcome To Gremlin Reliability Management
        </Typography>
        <Grid container direction="row" spacing={2}>
          <Grid item lg={9} xs={12}>
            <PrepareToDefineServicesTutorial
              numberOfActiveClients={activeClients?.length}
              numberOfHealthyClients={allHealthyClients?.length}
            />
          </Grid>
          <Grid item lg={3} xs={12}>
            <ReliabilityManagement101 />
          </Grid>
        </Grid>
      </Content>
    </>
  )
}
